// extracted by mini-css-extract-plugin
export default {"custom-vars":"custom-vars__Gmp8t"};